module.exports = __webpack_public_path__ + "static/media/greenWig.326322f1.png";